const M = "/mockups/approved";

const phone = (file, title, alt, eyebrow) => ({
  src: `${M}/${file}`,
  title,
  alt,
  eyebrow,
  device: "phone",
});

const mac = (file, title, alt) => ({
  src: `${M}/${file}`,
  title,
  alt,
  eyebrow: "Compra desde la web",
  device: "mac",
});

export const GALLERIES = {
  pagos: [
    phone("NEW-PAGOS.webp", "Detalle verificable", "Detalle de un movimiento en Aurexis con hash y referencia", "Pagos"),
    phone("IP16P-PAGOS-002.png", "Contactos personales", "Contactos guardados por FSC ID", "Pagos"),
    phone("IP16P-PAGOS-003.png", "Movimientos", "Historial de movimientos en Aurexis", "Pagos"),
    phone("IP16P-PAGOS-004.png", "Detalle verificable", "Detalle de un pago completado", "Pagos"),
    phone("IP16P-PAGOS-005.png", "Tickets", "Comprobantes de operaciones en Aurexis", "Pagos"),
    phone("IP16P-PAGOS-006.png", "Por cobrar", "Solicitudes de cobro emitidas", "Pagos"),
    phone("IP16P-PAGOS-007.png", "Cobro liquidado", "Detalle de una solicitud de cobro pagada", "Pagos"),
  ],
  checkout: [
    phone("IP16P-PLUGIN-001.webp", "Plugin conectado", "Plugin web conectado a Aurexis", "Plugin Aurexis"),
    mac("MACBOOK-PLUGIN-001.png", "Ingresa tu FSC ID", "Checkout web para ingresar el FSC ID"),
    mac("MACBOOK-PLUGIN-002.png", "Solicitud enviada", "Checkout web esperando confirmación desde Aurexis"),
    phone("IP16P-PLUGIN-002.png", "Solicitud en tu app", "Solicitud de cobro pendiente en Aurexis", "Plugin Aurexis"),
    phone("IP16P-PLUGIN-003.png", "Confirma el pago", "Confirmación del pago web desde Aurexis", "Plugin Aurexis"),
    phone("IP16P-PLUGIN-004.png", "Listo en tu app", "Pago web completado en Aurexis", "Plugin Aurexis"),
    mac("MACBOOK-PLUGIN-003.png", "Compra completada", "Pago web completado en una MacBook Pro"),
  ],
  automatizacion: [
    phone("NEW-AUTO.webp", "Programa tus pagos", "Formulario de automatización con pagos programados", "Automatización"),
    phone("IP16P-AUTO-005.png", "Verifica el destinatario", "Destinatario verificado para una automatización", "Automatización"),
    phone("IP16P-AUTO-003.png", "Programa el pago", "Fecha, hora e importe de un pago programado", "Automatización"),
    phone("IP16P-AUTO-004.png", "Revisa la programación", "Pago programado listo para continuar", "Automatización"),
    phone("IP16P-AUTO-002.png", "Confirma el resumen", "Resumen antes de crear una automatización", "Automatización"),
    phone("IP16P-AUTO-001.png", "Plan activo", "Automatización activa en Aurexis", "Automatización"),
  ],
  conservatorio: [
    phone("IP16P-CONS-001.webp", "Repositorio privado", "Vista principal del Conservatorio", "Conservatorio"),
    phone("IP16P-CONS-003.png", "Documentos certificados", "Repositorio con documentos certificados", "Conservatorio"),
    phone("IP16P-CONS-002.png", "Explora el repositorio", "Lista de documentos certificados en el Conservatorio", "Conservatorio"),
    phone("IP16P-CONS-004.png", "Detalle del documento", "Detalle verificable de un documento certificado", "Conservatorio"),
    phone("IP16P-CONS-005.png", "Titularidad y seguridad", "Opciones de seguridad de un documento", "Conservatorio"),
  ],
  rwa: [
    phone("NEW-RWA.webp", "Detalle del activo", "Activo Plaza Puebla tokenizado con valor en MXF", "Activos reales"),
    phone("IP16P-RWA-002.png", "Detalle del activo", "Detalle del activo Plaza Puebla", "Activos reales"),
    phone("IP16P-RWA-001.png", "Solicita una actualización", "Solicitud de actualización de datos de un RWA", "Activos reales"),
  ],
  multifirma: [
    phone("NEW-MULTI.webp", "Saldo mancomunado", "Cuenta mancomunada con operación compartida", "Multifirma"),
    phone("IP16P-MULTI-002.png", "Cuentas mancomunadas", "Lista de cuentas mancomunadas", "Multifirma"),
    phone("IP16P-MULTI-003.png", "Saldo compartido", "Inicio de una cuenta mancomunada", "Multifirma"),
    phone("IP16P-MULTI-004.png", "Participantes", "Participantes verificados de la cuenta", "Multifirma"),
    phone("IP16P-MULTI-005.png", "Esperando firmas", "Propuesta esperando firmas", "Multifirma"),
    phone("IP16P-MULTI-006.png", "Firma la propuesta", "Propuesta lista para firmar", "Multifirma"),
    phone("IP16P-MULTI-007.png", "Lista para ejecutar", "Propuesta lista para ejecutarse", "Multifirma"),
  ],
};

export const TEXTURES = {
  goldReflection:
    "https://images.unsplash.com/photo-1650394850853-bad61e0f6c75?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxnb2xkJTIwbGlnaHQlMjByZWZsZWN0aW9uJTIwYWJzdHJhY3R8ZW58MHx8fHwxNzgyMDMzOTU5fDA&ixlib=rb-4.1.0&q=85",
  architecture:
    "https://images.unsplash.com/photo-1496865534669-25ec2a3a0fd3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};
